module.exports = __webpack_public_path__ + "img/04.57a43847.jpg";